import { useRef } from 'react'
import { useThree } from '@react-three/fiber'

// Disable this component as we're using SectionTitles for section display instead
export function SectionOverlay() {
  const ref = useRef()
  
  // Return empty group - we're using DOM-based SectionTitles component instead
  return <group ref={ref} />
} 